import React from 'react';
import Loader from '../../../../../../core/components/campaigns/campaigndetails/transactionsTabV2/TransactionsTabLoader';
import Controller from '../../../../../../core/components/campaigns/campaigndetails/transactionsTabV2/TransactionsTabController';
import View from './TransactiosTab';

// Feature level subroutes
const TransactionsTabV2 = (props) => {
  return (
    <Loader {...props}>
      <Controller>
        <View />
      </Controller>
    </Loader>
  );
};

export default TransactionsTabV2;
